import { NestedPublicationParams } from "interfaces/routing/nested-publication-params";
import { PublicationParams } from "interfaces/routing/publication-params";
import PublicationContentRedirect from "organisms/publication-content/legacy-redirects/publication-content-redirect";
import React from "react";
import { useParams } from "react-router-dom";
import { siteMap } from "internal-sitemap";
import usePublicationQuery from "utilities/hooks/domain/publications/use-publication-query";
import useChapterQuery from "utilities/hooks/queries/publications/chapters/use-chapter-query";
import useAdminPreview from "utilities/hooks/use-admin-preview";
import useLoading from "utilities/hooks/use-loading";
import NumberUtils from "utilities/number-utils";
import { RouteUtils } from "utilities/route-utils";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

export interface ChapterRedirectProps {}

interface RouteParams
    extends Pick<NestedPublicationParams, "publicationId">,
        Pick<PublicationParams, "id"> {}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const ChapterRedirect: React.FC<ChapterRedirectProps> = (
    props: ChapterRedirectProps
) => {
    const { publicationId, id: chapterId } = useParams<RouteParams>();

    const { isAdminPreview } = useAdminPreview();

    const {
        resultObject: chapter,
        loaded: chapterLoaded,
        loading: chapterLoading,
    } = useChapterQuery({
        id: chapterId,
    });
    const {
        resultObject: publication,
        loaded: publicationLoaded,
        loading: publicationLoading,
    } = usePublicationQuery({
        id: NumberUtils.parseInt(publicationId),
        isAdmin: isAdminPreview,
    });

    const loading = useLoading(chapterLoading, publicationLoading);
    const loaded = chapterLoaded && publicationLoaded;
    const route = RouteUtils.getUrl(siteMap.publications.permalinks.chapter, {
        code: publication.code,
        edition: publication.edition,
        nfpaLabel: chapter.nfpaLabel,
    });

    return (
        <PublicationContentRedirect
            entities={[chapter, publication]}
            loaded={loaded}
            loading={loading}
            route={route}
        />
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default ChapterRedirect;

// #endregion Exports
